import App from 'app/app.js';
import 'app/service/EventService.js';

function ChangeActiveOrderAction(EventService) {
  this.eventName = 'activeOrderChanged';

  this.dispatch = function (contentMap) {
    EventService.dispatch(this.eventName, contentMap);
  };

  this.register = function (listener) {
    return EventService.register(this.eventName, listener);
  };
}

App.service('ChangeActiveOrderAction', ['EventService', ChangeActiveOrderAction]);
